import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "cart-checkout__finalize" };
const _hoisted_2 = { class: "mb-2 mt-3" };
const _hoisted_3 = { class: "item" };
const _hoisted_4 = { class: "container-fluid p-0 m-0 border border-bottom-0" };
const _hoisted_5 = { class: "row p-0 pb-2 pt-2 m-0 fw-bold border-bottom" };
const _hoisted_6 = { class: "col-12 col-xl-8" };
const _hoisted_7 = { class: "d-none d-xl-block col-xl-2 text-center" };
const _hoisted_8 = { class: "d-none d-xl-block col-xl-2 text-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    const _component_g_cart_checkout__line_item = _resolveComponent("g-cart-checkout__line-item");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.status.mode === 'summary' && _ctx.schema?.options?.agb_Caption)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.schema?.options?.agb_Caption), 1)
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(['mb-4 data-box__select', _ctx.status.hasConditionError ? 'bg-light border-danger text-danger' : ''])
                }, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.data.conditionsconfirmed) = $event))
                            }, null, 512), [
                                [_vModelCheckbox, _ctx.data.conditionsconfirmed]
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            _createVNode(_component_g_dynamic_html, {
                                template: _ctx.schema?.options?.agb_Text
                            }, null, 8, ["template"])
                        ])
                    ])
                ], 2)
            ], 64))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$tc('client.Commerce.Carts.ItemDescription')), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Quantity')), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$tc('client.Commerce.Carts.TotalAmount')), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cart.lines, (item) => {
                return (_openBlock(), _createBlock(_component_g_cart_checkout__line_item, {
                    key: item.lineID,
                    cart: _ctx.cart,
                    item: item,
                    schema: _ctx.schema,
                    data: _ctx.data,
                    status: _ctx.status,
                    "is-read-only": true,
                    onCommand: _ctx.onCommand
                }, null, 8, ["cart", "item", "schema", "data", "status", "onCommand"]));
            }), 128))
        ])
    ]));
}
